export enum DealStatus {
  InitialContactProspecting = 1,
  Qualification,
  SolutionPresentation,
  ProposalSubmission,
  FinalNegotiation,
  FinalApproval,
  ContractSigning,
  ClosedWonAndPostSaleFollowUp,
  ClosedLost,
}
